import { DocumentationPageContent } from "@supernova-studio/model";
import { z } from "zod";
//
// Read
//
export const DTODocumentationPageContent = DocumentationPageContent;
export const DTODocumentationPageContentGetResponse = z.object({
    pageContent: DTODocumentationPageContent,
});
